<template>
  <div class="w-full px-2 md:px-8 pb-8 pt-5 flex flex-col shadow-lg rounded-lg my-5">
    <div class="flex flex-row justify-between w-full
      pb-2 lg:pb-2 mb-2 border-b-2 border-grey-academy-150
      items-center">
      <round-photo-and-name
        containerClass="items-center"
        textClass="text-left pl-2 invisible md:visible"
        photoClass="w-8 ml-2 md:ml-0"
        :person="review.student" />
        <stars-rate
        class="w-1/6 md:w-1/2 justify-end"
        :starsAvg="review.teacher_avg" starsClass="w-7 lg:w-10 p-1" />
    </div>
    <div class="flex flex-col items-start p-2">
      <span class="pb-4 uppercase text-lg">
        {{ review.lesson.tier.name }}
      </span>
      <p class="text-left font-sans-serif">{{ review.teacher_review }}</p>
    </div>
  </div>
</template>

<script>
import RoundPhotoAndName from '../graphics/RoundPhotoAndName.vue';
import StarsRate from '../graphics/StarsRate.vue';

export default {
  components: { RoundPhotoAndName, StarsRate },
  props: ['review'],
};
</script>
